<template>
  <div class="user-wrapper d-flex justify-content-between align-items-center">
    <b-link
      :to="blocLink"
      class="d-flex"
      :class="
        linkOnly ? 'w-100 justify-content-between align-items-center' : ''
      "
    >
      <div class="nom-user">
        <p>{{ titre }}</p>
        <span>{{ sousTitre }}</span>
      </div>

      <div class="action-group">
        <span v-if="dataId !== 135 && roleAdmin">
          <span @click.prevent="handleEditProject">
            <font-awesome-icon :icon="['far', 'edit']"/>
          </span>
          <span @click.prevent="handleDeleteProject">
            <font-awesome-icon :icon="['far', 'trash-alt']"/>
          </span>
        </span>

        <font-awesome-icon :icon="['fas', 'chevron-right']" />
      </div>
    </b-link>
    <div class="action-client" v-if="role">
      <ul class="d-flex">
        <li>
          <b-link :to="'/dashboard/edit-user/' + clientId + '/' + userId"
            ><font-awesome-icon :icon="['far', 'edit']"
          /></b-link>
        </li>
        <li>
          <span
            @click="deleteEvent"
            :style="{ color: 'red', cursor: 'pointer' }"
            ><font-awesome-icon :icon="['far', 'trash-alt']"
          /></span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import store from '@/store'
export default {
  props: {
    blocLink: {
      type: String,
      required: false
    },
    titre: {
      type: String,
      required: false
    },
    sousTitre: {
      type: String,
      required: false
    },
    dataId: {
      type: Number
    },
    userId: {
      type: String,
      required: false
    },
    clientId: {
      type: String,
      required: false
    },
    linkOnly: {
      type: Boolean,
      default: false
    },
    template: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    if (this.template) {
      store.commit('TEMPLATE_ID', this.dataId)
    }
  },
  data () {
    return {
      role: store.getters.userRole === 'ROLE_EDITEUR',
      roleAdmin: store.getters.userRole === 'ROLE_ADMIN'
    }
  },
  methods: {
    deleteEvent () {
      this.$emit('delete', this.userId)
    },
    handleEditProject () {
      this.$emit('editProject', this.dataId)
    },
    handleDeleteProject () {
      this.$emit('deleteProject', this.dataId)
    }
  }
}
</script>
<style lang="scss">
$primary: #236aa3;
.user-wrapper {
  // box-shadow: 0 2px 3px 0 rgba(225, 225, 225, 0.5);
  border-radius: 4px;
  border: 1px solid #2b3085;
  padding: 0px 5px;
  color: #2b3085;
  position: relative;
  //min-height: 80px;
  vertical-align: middle;
  align-items: center;
  margin-bottom: 13px;
  //height: 30px;
  p {
    font-family: "Open sans";
    font-size: 15px;
    line-height: 30px;
    margin-bottom: 0;
  }
  .nom-user {
    span {
      font-family: "Noto sans", sans-serif;
      opacity: 0.6;
      font-size: 12px;
      line-height: 14px;
    }
  }
  .caret-icon {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
  }
}

.action-client {
  ul {
    padding-left: 0;
    list-style: none;
    margin-bottom: 0;
    li {
      padding-left: 5px;
      padding-right: 5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/utils/blocTypeUser.vue